/**
 * DPos
 * API for DPos
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface VoucherUsageReportDto { 
    createdByName?: string;
    discountAmount?: number;
    id?: number;
    originalTotal?: number;
    paymentId?: number;
    paymentNo?: string;
    usageDate?: string;
    voucherCode?: string;
    voucherName?: string;
    voucherType?: string;
}

